// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

export const isEmailIpWarmingAppGroupIdRequiredEmailTemplatesResult = objectOf({
  number_of_required_email_templates: number,
});
